import React, { memo, useMemo } from 'react'
import PropTypes from 'prop-types'
import { Handle, Position } from '@xyflow/react'
import { getVariantStyles, getSizeStyles } from './variants'
import NodeContent from './NodeContent'

const HANDLE_STYLE = { width: 6, height: 6 }

function FlowGraphCard ({ data, selected }) {
  const {
    nameValue, nameConfig,
    descriptionValue, descriptionConfig,
    image,
    variant = 'default',
    size = 'md'
  } = data

  const variantStyles = getVariantStyles(variant)
  const sizeStyles = getSizeStyles(size)

  const isFilled = variant !== 'default'

  const containerStyle = useMemo(() => ({
    background: variantStyles.background,
    border: `2px solid ${selected ? variantStyles.selectedBorderColor : variantStyles.borderColor}`,
    borderRadius: '24px',
    padding: sizeStyles.padding,
    width: sizeStyles.width,
    boxSizing: 'border-box',
    fontSize: sizeStyles.fontSize,
    boxShadow: selected
      ? '0 0 0 3px rgba(139, 92, 246, 0.25)'
      : '0 2px 4px rgba(0, 0, 0, 0.1)',
    cursor: 'pointer',
    transition: 'box-shadow 0.15s ease, border-color 0.15s ease',
    textAlign: 'center',
    overflow: 'hidden'
  }), [variantStyles, sizeStyles, selected])

  const handleColor = isFilled
    ? variantStyles.borderColor
    : 'var(--color-neutral-300)'

  return (
    <div style={containerStyle}>
      <Handle
        type='target'
        position={Position.Top}
        style={{ ...HANDLE_STYLE, background: handleColor }}
      />
      <NodeContent
        nameValue={nameValue}
        nameConfig={nameConfig}
        descriptionValue={descriptionValue}
        descriptionConfig={descriptionConfig}
        image={image}
        variantColor={isFilled ? variantStyles.color : undefined}
      />
      <Handle
        type='source'
        position={Position.Bottom}
        style={{ ...HANDLE_STYLE, background: handleColor }}
      />
    </div>
  )
}

FlowGraphCard.propTypes = {
  data: PropTypes.shape({
    nameValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    nameConfig: PropTypes.object,
    descriptionValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    descriptionConfig: PropTypes.object,
    image: PropTypes.string,
    variant: PropTypes.string,
    size: PropTypes.string
  }),
  selected: PropTypes.bool
}

export default memo(FlowGraphCard)
